import { getAllCategory } from '@/api/category'
//import { category } from '@/api/shClass'

// 分类模块
export default {
  namespaced: true,
  state() {
    return {
      // 分类信息集合
      //booklist:category,
      list: [],
    }
  },
  //payload为拿到的分类数组
  mutations: {
    setList(state, payload) {
      state.list = payload
    }
  },
  //获取分类函数
  actions: {
    async getList({ commit }) {
      //获取分类数据接口
      const result = await getAllCategory()
      // 获取数据成功，提交mutations进行数据修改
      commit('setList', result)
    }
  }
}
